interface StoredChatState {
  conversationId: string | null;
  convStatus?: 'active' | 'escalated' | 'resolved';
}

function storageKey(tenantDomain: string, userId: string, agentId: string): string {
  return `r41-support-chat:${tenantDomain}:${userId}:${agentId}`;
}

export function loadChatState(tenantDomain: string, userId: string, agentId: string): StoredChatState | null {
  try {
    const raw = localStorage.getItem(storageKey(tenantDomain, userId, agentId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.conversationId !== 'string' && parsed.conversationId !== null) return null;
    const convStatus = ['active', 'escalated', 'resolved'].includes(parsed.convStatus)
      ? (parsed.convStatus as 'active' | 'escalated' | 'resolved')
      : undefined;
    return { conversationId: parsed.conversationId, convStatus };
  } catch {
    return null;
  }
}

export function saveChatState(tenantDomain: string, userId: string, agentId: string, state: StoredChatState): void {
  try {
    localStorage.setItem(storageKey(tenantDomain, userId, agentId), JSON.stringify(state));
  } catch {
    // localStorage full or unavailable — non-critical
  }
}

export function clearChatState(tenantDomain: string, userId: string, agentId: string): void {
  try {
    localStorage.removeItem(storageKey(tenantDomain, userId, agentId));
  } catch {
    // non-critical
  }
}
